// export const BASE_URL="https://www.developer-beta.com/p4/kotresh/public";     
// http://cnc-maintenancecoach.com/admin/public/login
export const BASE_URL="https://www.cnc-maintenancecoach.com/admin/public";